import api from "./api";

class KioskService {
  getBranchSetting(dataForm) {
    return api.post("/kiosk/get-branch-setting", dataForm);
  }

  verifyReaderStateStripe(dataForm) {
    return api.post("/kiosk/verify-reader-state", dataForm);
  }

  verifyReaderStateAllinpay(dataForm) {
    return api.post("/allinpay/verify-reader-state", dataForm);
  }

  createPaymentIntent(dataForm) {
    return api.post("/kiosk/create-payment-intent", dataForm);
  }

  createPaymentIntentPaynow(dataForm) {
    return api.post("/kiosk/create-payment-intent-paynow", dataForm);
  }

  processPaymentPaynow(dataForm) {
    return api.post("/kiosk/process-payment-paynow", dataForm);
  }

  requestPaymentReader(dataForm) {
    return api.post("/kiosk/request-payment-reader", dataForm);
  }

  cancelPaymentIntent(dataForm) {
    return api.post("/kiosk/cancel-payment-intent", dataForm);
  }

  cancelReaderAction(dataForm) {
    return api.post("/kiosk/cancel-reader-action", dataForm);
  }

  saveOrder(dataForm) {
    return api.post("/kiosk/save-order", dataForm);
  }

  checkPaymentIntentStatus(dataForm) {
    return api.post("/kiosk/check-payment-intent-status", dataForm);
  }
  
  getOrderStatus(dataForm) {
    return api.post("/kiosk/get-order-status", dataForm);
  }

  getOrderDetail(dataForm) {
    return api.post("/kiosk/get-order-detail", dataForm);
  }

  /**
   * Short-lived socket token for the one order this kiosk just placed.
   *
   * The same endpoint MOO uses — the order lookup and the merchant/branch guard
   * behind it are identical, and the room it grants is the one order either way.
   * `device_type` only changes how the websocket server logs and counts this
   * socket, which is the difference between being able to answer "are the kiosks
   * actually on realtime?" and guessing.
   *
   * Returns { enabled: false } when realtime is switched off server-side, which
   * is a normal answer: the screen keeps polling.
   */
  getWsTokenForOrder(dataForm) {
    return api.post("/ws-token/order", { ...dataForm, device_type: "kiosk" });
  }

  retryOrder(dataForm) {
    return api.post("/kiosk/retry-order", dataForm);
  }

  searchItem(dataForm) {
    // Barcode scan on the kiosk: a QR channel, so POS-only items are not returned.
    return api.post('/kiosk/search-item', { ...dataForm, from_qr: 1 });
  }

  confirmPinCode(dataForm) {
    return api.post('/kiosk/check-pin-code', dataForm);
  }

  confirmPasscode(dataForm, merchant_code) {
    return api.post(`${process.env.VUE_APP_BASE_MINTY_URL}/member/check-passcode`, dataForm, {
      headers: {
        'MerchantCode': merchant_code
      }
    });
  }

  checkStaff(dataForm, merchant_code) {
    return api.post(`${process.env.VUE_APP_BASE_MINTY_URL}/member/check-staff`, dataForm, {
      headers: {
        'MerchantCode': merchant_code
      }
    });
  }

  getStaffRemainingSpending(dataForm) {
    return api.post('/kiosk/get-staff-remaining-spending', dataForm);
  }

  checkPromoCode(dataForm) {
    return api.post('/kiosk/check-promo-code', dataForm);
  }

  sendOtpToWhatsApp(dataForm, merchant_code) {
    return api.post(`${process.env.VUE_APP_BASE_MINTY_URL}/pos/send-otp`, dataForm, {
      headers: {
        'MerchantCode': merchant_code
      }
    });
  }

  verifyOtp(dataForm, merchant_code) {
    return api.post(`${process.env.VUE_APP_BASE_MINTY_URL}/pos/validate-otp`, dataForm, {
      headers: {
        'MerchantCode': merchant_code
      }
    });
  }

  directDeduct(dataForm, merchant_code) {
    return api.post(`${process.env.VUE_APP_BASE_MINTY_URL}/pos/direct-deduct`, dataForm, {
      headers: {
        'MerchantCode': merchant_code
      }
    });
  }

  getHome(merchant_code) {
    return api.get(`${process.env.VUE_APP_BASE_MINTY_URL}/member/home`, {
      headers: {
        'MerchantCode': merchant_code
      }
    });
  }

  generateQRMemberSignIn(merchant_code) {
    return api.post(`${process.env.VUE_APP_BASE_MINTY_URL}/generate-member-sign-in-qr`, {
      headers: {
        'MerchantCode': merchant_code
      }
    });
  }

}

export default new KioskService();
